import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import { SELECT_ITEM_DEFAULT } from 'config';
import { getList, getOne } from 'api/roleApi';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

export default class SelectTinhTrang extends React.Component {
  static propTypes = {
    width: PropTypes.any,
    hideLabel: PropTypes.bool,
    fieldForm: PropTypes.shape({
      form: PropTypes.any,
      name: PropTypes.string,
      option: PropTypes.object,
    }),
  };

  state = {
    itemList: [SELECT_ITEM_DEFAULT],
    valueSelect: {
      value: null,
      label: '-- Select --',
    },
  };

  componentWillMount = async () => {
    const requestItemList = await getList();

    if (requestItemList.success)
      this.setState({
        itemList: [
          SELECT_ITEM_DEFAULT,
          ...requestItemList.data.map((item) => {
            return { value: item._id, label: item.Name };
          }),
        ],
      });
  };

  resetValue = () => {
    this.setState({ valueSelect: { value: null, label: '-- Select --' } });
  };

  componentDidUpdate = async (prevProps, prevState) => {
    const { valueSelect } = this.state;
    const { isUpdate } = this.props;
    const requestRole = await getOne(valueSelect.value);
    const requestItemList = await getList();

    if (prevProps.isUpdate !== isUpdate) {
      if (requestRole.success) {
        this.setState({
          valueSelect: {
            value: requestRole.data._id,
            label: requestRole.data.Name,
          },
          itemList: [
            SELECT_ITEM_DEFAULT,
            ...requestItemList.data.map((item) => {
              return { value: item._id, label: item.Name };
            }),
          ],
        });
      }
    }
  };

  render() {
    const { valueSelect } = this.state;
    const { fieldForm } = this.props;
    let getFieldProps = {};
    if (fieldForm) {
      getFieldProps = fieldForm.form.getFieldProps(fieldForm.name, {
        ...fieldForm.option,
      });
    }

    const isHidden = {
      style: {
        display: this.props.hideLabel ? 'none' : '',
      },
    };

    return (
      <Container>
        <span {...isHidden}>Vai trò</span>
        <Clearfix {...isHidden} width={8} />
        <div style={{ flex: 1 }}>
          <Select
            placeholder='-- Select --'
            style={{
              flex: 1,
            }}
            classNamePrefix='react-select-custom'
            options={this.state.itemList}
            {...this.props}
            {...getFieldProps}
            value={valueSelect}
            onChange={(obj) => {
              this.setState({ valueSelect: obj });
              if (this.props.onChange) {
                this.props.onChange(obj && obj.value ? obj : undefined);
              }
            }}
          />
        </div>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/select-role/index.js